import type { BioPod } from "@/features/pods/types";
import { MOCK_PODS } from "@/features/pods/mockPods";

/**
 * Where pod data comes from.
 *
 * The screens depend on this interface and never on a concrete source, so moving from mock data to
 * the fleet's discovery worker is one new implementation and one line in `podsRepository`, with no
 * change to any component.
 */
export interface PodsRepository {
  listPods(): Promise<BioPod[]>;
  /** Null when no pod has that id, which is a 404 for the caller, not an error. */
  getPod(id: string): Promise<BioPod | null>;
}

const mockPodsRepository: PodsRepository = {
  listPods: () => Promise.resolve(MOCK_PODS),
  getPod: (id) => Promise.resolve(MOCK_PODS.find((pod) => pod.id === id) ?? null),
};

/**
 * The repository the app uses.
 *
 * Mock until the fleet runs `fleet_discovery_worker` - nothing in bioapp-v2 reads biopod data yet,
 * so that worker is deliberately absent from this fleet's `fleet_workers.toml`.
 */
export const podsRepository: PodsRepository = mockPodsRepository;
